import { render } from "./GeneralInformationBar.vue?vue&type=template&id=5d89f74a"
import script from "./GeneralInformationBar.vue?vue&type=script&lang=js"
export * from "./GeneralInformationBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__